import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) =>
     {  console.log(`${host}/itsm/${project}/get_incident_details_pagination?${params}`)
    return `${host}/itsm/${project}/get_incident_details_pagination?${params}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined) throw new Error("No ticket data supplied.")
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)